export function isValueOther(text) {
    return /^\+[0-9]+ Others$/.test(text);
}
